import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import OptimizedImage from '../components/ui/OptimizedImage';
import Button from '../components/ui/Button';
import { ArrowRightIcon, LandmarkIcon, CrownIcon, BookOpenIcon } from 'lucide-react';
const TownHistory = () => {
  return <div className="min-h-screen bg-white" data-id="element-5986">
      <PageHeader title="History of Isonyin Town" description="Discover the rich heritage and cultural legacy of the Isonyin community." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/1M2HvxLSgR9d6nbohZ1s5G/WhatsApp_Image_2025-11-07_at_19.21.03_%281%29.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Town History',
      path: '/town-history'
    }]} data-id="element-5987" />
      <div className="container mx-auto px-4 py-12" data-id="element-5988">
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-5989">
          <div className="text-center mb-10" data-id="element-5990">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5991">
              The Heritage of Isonyin
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5992"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5993">
              A community rich in tradition, culture, and educational excellence
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-12" data-id="element-5994">
            <div data-id="element-5995">
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-5996">
                Isonyin is a historic town in Ijebu North-East Local Government
                Area of Ogun State, Nigeria. The town has a rich cultural
                heritage and has been a center of learning and development for
                generations.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-5997">
                The establishment of Isonyin Grammar School in 1956 marked a
                significant milestone in the educational development of the town
                and surrounding communities. The school has been instrumental in
                producing leaders, professionals, and responsible citizens who
                have contributed to the development of Nigeria.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-5998">
                The town's commitment to education, combined with its strong
                traditional values and community spirit, has made it a model for
                other communities in the region.
              </p>
            </div>
            <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-5999">
              <OptimizedImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/534ff42aLM6duxTpTMjEFu/WhatsApp_Image_2025-11-07_at_19.21.04.jpg" alt="Aafin Saderiren Palace - Cultural Heritage" aspectRatio="16/9" className="w-full" data-id="element-6000" />
            </div>
          </div>
        </section>
        {/* Traditional Leadership Section */}
        <section className="mb-16" data-id="element-6001">
          <div className="text-center mb-10" data-id="element-6002">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6003">
              Traditional Leadership
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6004"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6005">
              The Saderiren of Isonyin-Ijebu: Guardian of tradition and progress
            </p>
          </div>
          <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white rounded-lg overflow-hidden mb-8" data-id="element-6006">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0" data-id="element-6007">
              <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-6008">
                <div className="inline-block p-3 bg-yellow-500/20 rounded-full w-fit mb-6" data-id="element-6009">
                  <CrownIcon className="h-8 w-8 text-yellow-400" data-id="element-6010" />
                </div>
                <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-6011">
                  HRM Oba Abdul-Rasheed Omorato Cossy Salami
                </h3>
                <p className="text-xl text-yellow-300 mb-6" data-id="element-6012">Ilufemiloye I</p>
                <p className="text-lg mb-4 leading-relaxed" data-id="element-6013">
                  The Saderiren of Isonyin-Ijebu
                </p>
                <p className="text-gray-200 leading-relaxed mb-6" data-id="element-6014">
                  His Royal Majesty has been a pillar of support for Isonyin
                  Grammar School and the entire community. His commitment to
                  education and community development has been instrumental in
                  the school's continued growth and success.
                </p>
                <p className="text-gray-200 leading-relaxed" data-id="element-6015">
                  Under his leadership, the town has experienced significant
                  development in education, infrastructure, and cultural
                  preservation, while maintaining the rich traditions that
                  define the Isonyin community.
                </p>
              </div>
              <div className="relative h-full min-h-[400px]" data-id="element-6016">
                <OptimizedImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/uwMfzv3rhajfnyG9e7Rdgw/WhatsApp_Image_2025-11-07_at_19.21.02.jpg" alt="HRM Oba Abdul-Rasheed Omorato Cossy Salami - Saderiren of Isonyin" className="w-full h-full" objectFit="cover" data-id="element-6017" />
              </div>
            </div>
          </div>
          {/* Palace Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-6018">
            <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-6019">
              <OptimizedImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/6pinaRDuajwDJQoabZm9PG/WhatsApp_Image_2025-11-07_at_19.21.03.jpg" alt="Aafin Saderiren Palace Interior - Royal Thrones" aspectRatio="16/9" className="w-full" data-id="element-6020" />
            </div>
            <div data-id="element-6021">
              <div className="inline-block p-3 bg-blue-100 rounded-full mb-4" data-id="element-6022">
                <LandmarkIcon className="h-6 w-6 text-blue-700" data-id="element-6023" />
              </div>
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-6024">
                The Aafin Saderiren Palace
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-6025">
                The palace of the Saderiren stands as a symbol of the town's
                rich cultural heritage and traditional values. It serves as the
                seat of traditional authority and a center for community
                gatherings and cultural celebrations.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-6026">
                The palace has been a place where important decisions affecting
                the community are made, and where the traditions and customs of
                the Isonyin people are preserved and passed down to future
                generations.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-6027">
                The architectural design and royal regalia within the palace
                reflect the dignity and prestige of the traditional institution,
                showcasing the cultural sophistication of the Isonyin people.
              </p>
            </div>
          </div>
        </section>
        {/* Community Development Section */}
        <section className="mb-16" data-id="element-6028">
          <div className="text-center mb-10" data-id="element-6029">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6030">
              Community Development & Education
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6031"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6032">
              A tradition of excellence and progress
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-6033">
            <div className="bg-blue-50 p-6 rounded-lg" data-id="element-6034">
              <div className="inline-block p-3 bg-blue-100 rounded-full mb-4" data-id="element-6035">
                <BookOpenIcon className="h-6 w-6 text-blue-700" data-id="element-6036" />
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-6037">
                Educational Heritage
              </h3>
              <p className="text-gray-700 text-sm" data-id="element-6038">
                Since 1956, Isonyin has been home to one of the most prestigious
                secondary schools in Ogun State, producing thousands of
                successful graduates.
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg" data-id="element-6039">
              <div className="inline-block p-3 bg-blue-100 rounded-full mb-4" data-id="element-6040">
                <CrownIcon className="h-6 w-6 text-blue-700" data-id="element-6041" />
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-6042">
                Traditional Values
              </h3>
              <p className="text-gray-700 text-sm" data-id="element-6043">
                The community maintains strong traditional institutions that
                guide moral and ethical development alongside modern education.
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg" data-id="element-6044">
              <div className="inline-block p-3 bg-blue-100 rounded-full mb-4" data-id="element-6045">
                <LandmarkIcon className="h-6 w-6 text-blue-700" data-id="element-6046" />
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-6047">
                Community Spirit
              </h3>
              <p className="text-gray-700 text-sm" data-id="element-6048">
                The people of Isonyin demonstrate remarkable unity and
                collective responsibility in supporting education and community
                development.
              </p>
            </div>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200" data-id="element-6049">
            <h3 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-6050">
              The Role of Traditional Leadership in Education
            </h3>
            <div className="space-y-4 text-gray-700" data-id="element-6051">
              <p className="leading-relaxed" data-id="element-6052">
                The traditional leadership of Isonyin, under the guidance of the
                Saderiren, has played a crucial role in the establishment and
                continued success of Isonyin Grammar School. The palace has
                consistently provided:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-6053">
                <li data-id="element-6054">Moral and spiritual guidance to students and staff</li>
                <li data-id="element-6055">Land and resources for school expansion</li>
                <li data-id="element-6056">Mediation and conflict resolution when needed</li>
                <li data-id="element-6057">Cultural education and preservation of heritage</li>
                <li data-id="element-6058">Community mobilization for school development projects</li>
                <li data-id="element-6059">Recognition and celebration of academic achievements</li>
              </ul>
              <p className="leading-relaxed" data-id="element-6060">
                This partnership between traditional authority and modern
                education has created a unique environment where students
                benefit from both contemporary learning and cultural wisdom,
                producing well-rounded individuals who respect tradition while
                embracing progress.
              </p>
            </div>
          </div>
        </section>
        {/* Cultural Significance Section */}
        <section className="mb-16" data-id="element-6061">
          <div className="bg-gradient-to-r from-yellow-500 to-yellow-400 rounded-lg overflow-hidden" data-id="element-6062">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0" data-id="element-6063">
              <div className="relative h-full min-h-[300px]" data-id="element-6064">
                <OptimizedImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/1M2HvxLSgR9d6nbohZ1s5G/WhatsApp_Image_2025-11-07_at_19.21.03_%281%29.jpg" alt="Aafin Saderiren Palace Entrance" className="w-full h-full" objectFit="cover" data-id="element-6065" />
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-6066">
                <h3 className="text-2xl md:text-3xl font-bold text-blue-900 mb-4" data-id="element-6067">
                  A Symbol of Unity and Progress
                </h3>
                <p className="text-blue-900 mb-4 leading-relaxed" data-id="element-6068">
                  The Aafin Saderiren palace stands as a testament to the
                  enduring strength of Isonyin's cultural identity. It
                  represents the bridge between our rich past and promising
                  future.
                </p>
                <p className="text-blue-900 leading-relaxed" data-id="element-6069">
                  Through the support of our traditional institution and the
                  collective effort of community members, Isonyin continues to
                  be a beacon of educational excellence and cultural
                  preservation in Ogun State.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Call to Action */}
        <section className="bg-blue-900 text-white rounded-lg p-8 md:p-12 text-center" data-id="element-6070">
          <h2 className="text-3xl font-bold mb-4" data-id="element-6071">Be Part of Our Legacy</h2>
          <p className="max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-6072">
            Join a community that values education, tradition, and excellence.
            Discover how Isonyin Grammar School continues to build on the strong
            foundation laid by our forefathers.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-6073">
            <Button href="/about" variant="primary" icon={<ArrowRightIcon data-id="element-6075" />} iconPosition="right" data-id="element-6074">
              Learn About Our School
            </Button>
            <Button href="/admissions" variant="outline" className="border-white text-white hover:bg-white/10" data-id="element-6076">
              Apply for Admission
            </Button>
          </div>
        </section>
      </div>
    </div>;
};
export default TownHistory;